
import Vue from "vue";
import { FileSharingService } from "@/services/file-sharing.service";
import AccountCenterFile from "@/models/account-center-file";
import { UploadStatus } from "@/models/upload-status";
import { base64encode } from "@/util/base64";
import { container } from "@/services/container";
import moment from "moment";
import { mapState } from "pinia";
import { useAuth } from "@/store/auth";
const fileSharingService: FileSharingService =
  container.get("fileSharingService");

export default Vue.extend({
  name: "FileSharing",
  components: {},
  filters: {
    formatDate(date: Record<string, unknown>) {
      return moment(date).format("Do MMMM YYYY, h:mm a");
    },
  },
  data: () => ({
    files: Array<AccountCenterFile>(),
    existingFiles: Array<any>(),
    selectedFiles: Array<number>(),
    fields: [
      { key: "index", label: "Actions", sortable: false },
      { key: "Key", label: "Filename", sortable: true },
      { key: "Date", sortable: true },
      { key: "Size", sortable: true },
    ],
    directory: "home/gareth_dev/",
    isLoading: false,
    isUploading: false,
  }),
  computed: {
    ...mapState(useAuth, ["isLoggedIn", "userGroup"]),
    uploadedFilesList(): string {
      return this.files ? this.files.map((f) => f.File.name).join(", ") : "";
    },
    uploadComplete() {
      return !this.files.find(
        (f) => f.status === Number(UploadStatus.NotUploaded)
      );
    },
    filesToBeDeletedConfirmation() {
      const fileNames = this.existingFiles
        .filter((f: any, index: number) => this.selectedFiles.includes(index))
        .map((f: any) => {
          return f.Key;
        });
      return this.selectedFiles.length > 1
        ? "Do you want to delete these files: " + fileNames.join(", ")
        : "Do you want to delete this file: " + fileNames[0];
    },
  },
  mounted() {
    (this as any).listFiles();
  },
  methods: {
    selectFile(index: number, checked: boolean) {
      checked
        ? this.selectedFiles.push(index)
        : (this.selectedFiles = this.selectedFiles.splice(index, 1));
    },
    downloadFiles() {
      this.selectedFiles.forEach((i) =>
        (this as any).downloadFile(this.existingFiles[i].Key)
      );
    },
    deleteFiles() {
      this.selectedFiles.forEach((i) => {
        fileSharingService
          .deleteFile(this.directory, this.existingFiles[i].Key)
          .then();
      });
      this.selectedFiles = [];
      (this as any).listFiles();
    },
    getIconAndVariant(status: UploadStatus): { icon: string; variant: string } {
      switch (status) {
        case UploadStatus.Success:
          return { icon: "check-circle", variant: "success" };
        case UploadStatus.Failed:
          return { icon: "x-circle", variant: "danger" };
        case UploadStatus.NotUploaded:
          return { icon: "dash-circle", variant: "secondary" };
        case UploadStatus.Uploading:
          return { icon: "file-earmark-arrow-up", variant: "info" };
        default:
          return { icon: "", variant: "" };
      }
    },
    removeFile(filename: string) {
      this.files = this.files.filter((f) => f.file.name !== filename);
    },
    removeDuplicates() {
      this.files = this.files.filter(function (file, index, inputArray) {
        return inputArray.indexOf(file) === index;
      });
    },
    listFiles(): void {
      this.isLoading = true;
      fileSharingService.listFiles(this.directory).then((data) => {
        this.existingFiles = data.Contents.map((f: any) => {
          f.Key = f.Key.replace(this.directory, "");
          return f;
        }).filter((s: any) => s.Size !== 0 && s.Key !== "");
        console.log(this.existingFiles);
        this.isLoading = false;
      });
    },
    handleFileDrop(e: DragEvent) {
      if (!e.dataTransfer) return;
      const droppedFiles: FileList = e.dataTransfer.files;
      [...droppedFiles].forEach((f) => {
        this.files.push(new AccountCenterFile(UploadStatus.NotUploaded, f));
      });
      (this as any).removeDuplicates();
    },
    handleFileInput(e: InputEvent & { target?: { files?: FileList } }) {
      if (!e.target || !e.target.files) return;
      [...e.target.files].forEach((f: File) => {
        this.files.findIndex((file) => file.File.name === f.name);
        this.files.push(new AccountCenterFile(UploadStatus.NotUploaded, f));
      });
      (this as any).removeDuplicates();
    },
    uploadFiles() {
      if (!this.uploadComplete) {
        this.isUploading = true;
        this.files
          .filter((fs) => fs.Status !== Number(UploadStatus.Success))
          .forEach((f) => {
            f.Status = UploadStatus.Uploading;
            fileSharingService
              .uploadFile(f.File.name, f.File, this.directory)
              .then((process) => {
                process.$response.httpResponse.statusCode === 200
                  ? (f.Status = UploadStatus.Success)
                  : (f.Status = UploadStatus.Failed);
                (this as any).listFiles();
              })
              .catch((err: any) => {
                console.log(err);
                f.Status = UploadStatus.Failed;
              });

            this.isUploading = false;
          });
      }
    },
    confirmDelete(filename: string) {
      fileSharingService
        .deleteFile(this.directory, filename)
        .then(() => (this as any).listFiles()); // call list files again
    },
    downloadFile(fileName: string) {
      fileSharingService.downloadFile(fileName, this.directory).then((f) => {
        const base64 = base64encode(f.Body);
        // mime type check
        const link = document.createElement("a");
        link.setAttribute("href", base64);
        link.download = f.name;
        link.click();

        // Create buffer and blob from S3 getObject response
        // const buffer = new Buffer(f.Body);
        // const blob = new Blob([f.Body], { type: f.ContentType });
        // const url = URL.createObjectURL(blob);
      });
    },
    formatBytes(bytes: number, decimals = 2): string {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
  },
});
